<template>
    <!-- Info box -->
    <infobox-generic v-if="params.errorLevel === 'WARNING' || params.infoMessage" :label="operationMessage" />
    <!-- Information Text Blocks -->
    <div v-if="params.errorLevel === 'INFO'" class="information-wrapper" :class="{ mobile: getMobileAppState }">
        <divider-generic dividerSize="medium" icon="check-folder" :title="t('operationInfo.dividerTitle')" :applyBorder="false"/>
        <!-- Operation Number -->
        <text-block-generic :params="operationNumberParams"/>
        <!-- Operation Date -->
        <text-block-generic :params="operationDateParams"/>
        <!-- Operation Time -->
        <text-block-generic :params="operationTimeParams"/>
    </div>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import InfoboxGeneric from '@/components/generic/infobox/Generic'

/* Vue */
import { computed } from 'vue'

/* Assets & Helpers */
import { getDate, getTimeWithSeconds } from '@/assets/scripts/dateBuilders'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/** props received
@params { Object } with:
	errorLevel {String}
	code {String}
	operationDate {String}
	operationId {Number}
	infoMessage {String}
	warningMessage {String}
    isRequested {Boolean}
*/

const props = defineProps({
	params: Object
})

/* mapGetters */
const { getMobileAppState } = mapGetters()

const operationNumberParams = computed(() => {
    return {
        label: props.params.isRequested ? t('operationInfo.requestNumberLabel') : t('operationInfo.operationNumberLabel'),
        content: props.params.operationId
    }
})

const operationDateParams = computed(() => {
	return {
        label: props.params.isRequested ? t('operationInfo.requestDateLabel') : t('operationInfo.operationDateLabel'),
        content: props.params.operationDate ? getDate(props.params.operationDate) : '',
        classes: 'capitalize'
    }
})

const operationTimeParams = computed(() => {
	return {
        label: props.params.isRequested ? t('operationInfo.requestTimeLabel') : t('operationInfo.operationTimeLabel'),
        content: props.params.operationDate ? getTimeWithSeconds(props.params.operationDate) : ''
    }
})

const operationMessage = computed(() => {
	let message = `${t('operationInfo.operationWaitingForApprovalMessage1')} <span>${t('operationInfo.operationWaitingForApprovalMessage2')}</span>`

	if (props.params.errorLevel === 'WARNING' && !props.params.code && props.params.warningMessage) message = props.params.warningMessage

	if (props.params.errorLevel === 'WARNING' && props.params.code === 'signed_operation_created' && props.params.warningMessage) {
		if (props.params.warningMessage.split('|').length > 1) {
			message = `${props.params.warningMessage.split('|')[0]} <span>${props.params.warningMessage.split('|')[1]}</span>`
		} else message = props.params.warningMessage
	}

	return message
})
</script>

<style lang="scss" scoped>
.information-wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;

    width: 100%;
}
</style>
